import type {TranslationKey, Translations} from 'notability-services-common-universal'

type ShouldSkipParam<Param> = Param extends `/${infer _}` // closing tag like </Component>
  ? true
  : Param extends `${infer _}/` // self-closing tag like br/ (from <br/>)
    ? true
    : Param extends 'br' // non-self-closing tags (ex. <br>)
      ? true
      : false

type ComponentParams<Str> = Str extends `${infer _}<${infer Param}>${infer Rest}`
  ? ShouldSkipParam<Param> extends true
    ? [...ComponentParams<Rest>]
    : [Param, ...ComponentParams<Rest>]
  : []

type ValuesForKey<K extends string> =
  | (K extends keyof Translations ? Translations[K] : never)
  | (`${K}_one` extends keyof Translations ? Translations[`${K}_one`] : never)
  | (`${K}_other` extends keyof Translations ? Translations[`${K}_other`] : never)

type RecordOrNever<K extends string, V> = [K] extends [never] ? never : Record<K, V>

export type TranslationComponentParamMap = {
  [K in TranslationKey]: RecordOrNever<ComponentParams<ValuesForKey<K & string>>[number], React.ReactElement<any>>
}
